<template>
    <div class="footer">
        <div class="copyright">
            Copyright &copy; {{ copytext }} - Version <strong>3.0.0-dev-{{ build }}</strong>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageFooter',
    props: {
        copyright: String,
        linkList: Array
    },
    computed: {
        build() {
            return this.$laravel.build
        },
        copytext() {
            return typeof this.copyright === 'undefined' ?  this.config.footer.copyright : this.copyright
        },
        links() {
            return typeof this.linkList === 'undefined' ? this.config.footer.links : this.linkList
        }
    }
}
</script>
